import React from 'react';
import { Spin } from 'antd';
import styled from 'styled-components';

const LogoSpinner = styled.div`
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  opacity: 0.7;
  background-image: url('/assets/images/fixtagone.png');
  background-size: contain;
  width: 35px;
  height: 35px;
  animation-name: spin;
  animation-duration: 1700ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
`;

export default function LoadingSpinner() {
  return <Spin indicator={<LogoSpinner />} />;
}
